import styled from '@emotion/styled';

// Page Layout
export const PageWrapper = styled.div`
  background: #ffffff;
  min-height: 100vh;
  padding: 0;
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  padding: 32px 40px;
  @media (max-width: 1400px) {
    padding: 12px 5px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-bottom: 8px;

  h1 {
    margin: 0px 0px 0px 0px !important;
  }

  @media (max-width: 1020px) {
    h1 {
      font-size: 20px !important;
    }
  }
`;

export const SkipLink = styled.span`
  color: #535862;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 16px;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  
  &:hover {
    background: #f9fafb;
  }
`;

export const NavigationWrapper = styled.div`
  background: #ffffff;
  padding: 24px 40px;
  border-top: 1px solid #e9eaeb;
`;

// Typography
export const IntroText = styled.div`
  font-size: 18px;
  line-height: 28px;
  color: #3f621a;
  font-weight: 500;
  font-family: Inter, sans-serif;
  margin-bottom: 12px;
  strong {
    font-weight: 600;
  }
  @media (max-width: 1020px) {
      font-size: 14px !important;
  }
`;

export const SubText = styled.div`
  font-size: 18px;
  font-family: Inter, sans-serif;
  color: #535862;
  margin-bottom: 12px;
  line-height: 28px;
  font-weight: 400;
  @media (max-width: 1020px) {
    font-size: 14px !important;
  }
`;

export const SubTextSecond = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 12px;
  font-family: Inter, sans-serif;
  color: #535862;
  @media (max-width: 1020px) {
    font-size: 12px !important;
  }
`;

export const NoteText = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-family: Inter, sans-serif;
  line-height: 20px;
  color: #3f621a;
  margin-bottom: 30px !important;
  @media (max-width: 1020px) {
    font-size: 12px !important;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #181d27;
  font-style: normal;
  font-family: Inter, sans-serif;
  line-height: 30px;
  margin: 32px 0 8px 0;
  @media (max-width: 1020px) {
    font-size: 18px !important;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 16px;
  font-family: Inter, sans-serif;
  color: #535862;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  @media (max-width: 1020px) {
    font-size: 14px !important;
  }
`;

// Info Link
export const InfoLinkWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 32px;
  cursor: pointer;

  &:hover span {
    text-decoration: underline;
  }
`;

export const QuestionIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #3f621a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #3f621a;
  font-weight: 600;
`;

export const InfoLink = styled.span`
  color: #3f621a;
  margin-left: 10px;
  text-decoration: underline;
  text-decoration-style: solid;
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 24px;

  font-weight: 600;
  @media (max-width: 1020px) {
    font-size: 14px !important;
  }
`;
